import React from "react";
import { Modal, Button } from "react-bootstrap";

function PopUp({
  onClose = () => {},
  onSave = () => {},
  containerClass = "",
  title = "",
  content = "",
  saveBtnText = "",
  closeBtnText = ""
}) {
  return (
    <Modal
      centered
      show={true}
      onHide={onClose}
      dialogClassName={containerClass}
    >
      <Modal.Header closeButton>
        {title ? <Modal.Title>{title}</Modal.Title> : null}
      </Modal.Header>

      <Modal.Body>
        <h5>{content}</h5>
      </Modal.Body>
      {closeBtnText || saveBtnText ? (
        <Modal.Footer>
          {closeBtnText ? (
            <Button onClick={onClose} size="xs" variant="secondary">
              {closeBtnText}
            </Button>
          ) : null}
          {saveBtnText ? (
            <Button onClick={onSave} size="xs" variant="primary">
              {saveBtnText}
            </Button>
          ) : null}
        </Modal.Footer>
      ) : null}
    </Modal>
  );
}

export { PopUp };
